export default __webpack_public_path__ + "static/media/HospitalatHome-BelfastHSCTrustv4.2220630BelfastTrustHospitalatHomeV4_3_flowchart.920122ee.jpg";